(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["g_password-footer"]) return;
  try {
    
    const pwdFooter = document.querySelector('[data-password-footer]');
    document.documentElement.style.setProperty('--password-footer-height', `${pwdFooter.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g_password-header"]) return;
  try {
    
    const pwdHeader = document.querySelector('[data-password-header]');
    document.documentElement.style.setProperty('--password-header-height', `${pwdHeader.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-buttons"] && !window.DesignMode) return;
  try {
    
  class ProductButtonsSection extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('[role="tab"]');
      this.panels = this.querySelectorAll('[role="tabpanel"]');
      this.init();
    }

    init() {
      if (this.buttons.length === 0) return;

      this.buttons.forEach(button => {
        button.addEventListener('click', (e) => this.onButtonClick(e));
      });

      const initialActiveButton = this.querySelector('[aria-selected="true"]');
      if (initialActiveButton) {
        this.setActiveStyles(initialActiveButton);
      }
    }

    onButtonClick(e) {
      const clickedButton = e.currentTarget;

      this.buttons.forEach(button => {
        this.setInactiveStyles(button);
      });
      
      this.panels.forEach(panel => panel.hidden = true);
      
      this.setActiveStyles(clickedButton);
      
      const panelId = clickedButton.getAttribute('aria-controls');
      const panelToShow = this.querySelector(`#${panelId}`);
      if (panelToShow) {
        panelToShow.hidden = false;
      }
    }
    
    setInactiveStyles(button) {
      button.setAttribute('aria-selected', 'false');
      button.style.backgroundColor = '';
      button.style.color = '';
      button.style.borderColor = '';
    }

    setActiveStyles(button) {
      button.setAttribute('aria-selected', 'true');
      button.style.backgroundColor = '#FF0000';
      button.style.color = '#FFFFFF';
      button.style.borderColor = '#FF0000';
    }
  }

  customElements.define('product-buttons-section', ProductButtonsSection);

  } catch(e) { console.error(e); }
})();
})();
